import { err, ok } from 'neverthrow'
import { evaluatorErrorWithNode } from '../../scriptevaluator/EvaluatorError'
import { functionNodeTypes, HelperFunction } from '../FunctionTypes'

export const HasAnyValueFunction: HelperFunction = {
	tokenName: 'HAS_ANY_VALUE',
	nodeType: functionNodeTypes.HasAnyValue,
	evaluate(node, evaluateExpr, context) {
		const args = node.arguments
		if (args.length < 1 || args.length > 2) {
			return err(evaluatorErrorWithNode('HAS_ANY_VALUE function expects one or two arguments', node))
		}
		const conceptResult = evaluateExpr(args[0])
		if (conceptResult.isErr()) return err(conceptResult.error)
		if (typeof conceptResult.value !== 'string') {
			return err(evaluatorErrorWithNode('HAS_ANY_VALUE function first argument must evaluate to a string', node))
		}
		if (args[1]) {
			const subconceptResult = evaluateExpr(args[1])
			if (subconceptResult.isErr()) return err(subconceptResult.error)
			if (Array.isArray(subconceptResult.value) || subconceptResult.value === undefined) {
				return err(evaluatorErrorWithNode('HAS_ANY_VALUE second argument must be a scalar value', node))
			}
			return ok(context.hasAnySubstatusValue(conceptResult.value, subconceptResult.value))
		}
		return ok(context.hasAnyValue(conceptResult.value))
	}
}
